import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  HostListener
} from '@angular/core';
import { Photo } from '../../entities/photo/photo.entity';
import { NgClass } from '@angular/common';
import {TranslocoPipe} from '@jsverse/transloco';
import {PortfolioPhoto} from '../../entities/portfolio/portfolio-photo.entity';
import {AppImageComponent} from '../image/image';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  imports: [
    NgClass,
    TranslocoPipe,
    AppImageComponent
  ],
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnChanges {
  @Input() open = false;
  @Input() photos: Photo[] | PortfolioPhoto[] | null = null;
  @Input() index = 0;
  @Output() onClose = new EventEmitter<void>();

  public currentImage: Photo | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['photos'] || changes['index'] || changes['open']) {
      this.setCurrentImage(this.index);
    }
  }

  setCurrentImage(index: number): void {
    if (this.photos && this.photos.length > 0 && index >= 0 && index < this.photos.length) {
      this.currentImage = this.photos[index];
    } else {
      this.currentImage = null;
    }
  }

  close(): void {
    this.onClose.emit();
  }

  prev(): void {
    if (this.photos && this.index > 0) {
      this.index--;
      this.setCurrentImage(this.index);
    }
  }

  next(): void {
    if (this.photos && this.index < this.photos.length - 1) {
      this.index++;
      this.setCurrentImage(this.index);
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboard(event: KeyboardEvent): void {
    if (!this.open) return;

    if (event.key === 'ArrowLeft') {
      this.prev();
    } else if (event.key === 'ArrowRight') {
      this.next();
    } else if (event.key === 'Escape') {
      this.close();
    }
  }
}
